import { Link } from "react-router-dom";

export default function SubMenuItem({
    icon,
    title,
    to,
    condition = true
}) {
    if (!condition) return null;
    
    return (
        <Link to={to}>
            <div className="submenu-item">
                {icon}
                {title}
            </div>
        </Link>
    );
}
